import type { IconData } from '@stacksjs/iconify-core'

export const chatBubbleOvalSmiley1Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24a22.4 22.4 0 0 0 2.858 10.983c-.943 2.496-1.828 5.378-2.407 8.257a2.305 2.305 0 0 0 2.807 2.71c2.751-.645 5.544-1.54 8.01-2.45A22.4 22.4 0 0 0 24 46.5c12.426 0 22.5-10.074 22.5-22.5S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M30.328 28.903a2 2 0 0 1 3.344 2.194C31.476 34.443 27.647 36 24 36s-7.476-1.556-9.672-4.903a2 2 0 1 1 3.344-2.194C18.976 30.89 21.397 32 24 32s5.024-1.11 6.328-3.097M17 15a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2a2 2 0 0 1 2-2m12 2a2 2 0 0 1 4 0v2a2 2 0 1 1-4 0z\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatBubbleOvalSmiley1Flat
